import { FILTER_CHANGE } from "./const";

/**
 * action
 *
 * @param {filter name} name filter name
 * @param {Array} values values array
 * @returns {Object} redux action object
 */
function action(name, values) {
  return {
    type: FILTER_CHANGE,
    name,
    values,
  };
}

export default action;
